import { render } from "./details.vue?vue&type=template&id=bc0b7ff4&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=bc0b7ff4&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0b7ff4"]])

export default __exports__